import { ImageAnchor } from "./util";

export class UrlImageAnchor extends ImageAnchor {}
customElements.define("sfml-url-image-a", UrlImageAnchor);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/image/url-image-anchor.ts